<template>
  <div>
    <v-container class="bdo-password-reset-container" fluid>
      <v-row v-if="!loading">
        <v-col md="4" offset-md="4">
          <v-card>
            <v-card-title class="mb-4">
              <h3>Please enter a new password</h3>
            </v-card-title>
            <v-form v-model="valid">
              <v-text-field
                class="pl-4 pr-4"
                id="matching_user"
                label="Matching user"
                v-model="matching_user"
                disabled
                outlined
                dense
              ></v-text-field>
              <v-text-field
                class="pl-4 pr-4"
                id="new_password"
                label="Password"
                type="password"
                v-model="change_password.new_password"
                :rules="newPasswordRules"
                outlined
                dense
              ></v-text-field>
              <v-text-field
                class="pl-4 pr-4"
                id="confirm_password"
                type="password"
                label="Confirm password"
                v-model="change_password.confirm_password"
                :rules="confirmPasswordRules"
                outlined
                dense
              ></v-text-field>
              <v-alert v-if="!valid" class="ml-4 mr-4" border="left" color="red lighten-2" dark>
                <span>Password does not meet the requirements:</span>
                <ul>
                  <li>Minimum 8 characters</li>
                  <li>Minimum one lowercase</li>
                  <li>Minimum one uppercase</li>
                  <li>Minimum one number</li>
                  <li>Minimum one special character</li>
                </ul>
              </v-alert>
              <div class="flex-row-wrapper">
                <div class="fg-1">
                  <v-btn class="primary-btn ml-4 mb-4" @click="submit" :disabled="!valid" :loading="btnLoading">
                    Change password »
                  </v-btn>
                </div>
              </div>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import helpers from '@/plugins/helpers'
import config from '@/config'
import store from '@/store/index.js'
export default {
  data: () => ({
    loading: true,
    matching_user: '',
    forgot_password_token: '',
    change_password: {
      new_password: '',
      confirm_password: '',
      token: ''
    },
    btnLoading: false,
    valid: false,
    newPasswordRules: [
      v => !!v || 'Password is required',
      v => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).*$/.test(v) || 'Password must be valid'
    ],
    validPassword: true
  }),
  computed: {
    invalid() {
      return this.change_password.new_password != this.change_password.confirm_password
    },
    confirmPasswordRules() {
      return [
        v => !!v || 'Password is required',
        v => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).*$/.test(v) || 'Password must be valid',
        v => v == this.change_password.new_password || 'Password must be the same'
      ]
    }
  },
  mounted() {
    this.getUser()
  },
  methods: {
    async getUser() {
      if (this.$route.params.forgotpasswordtoken) {
        this.change_password.token = this.$route.params.forgotpasswordtoken
        let response = await helpers.fetchApi(
          config.apiUrl + `forgot-password-user/${this.change_password.token}`,
          'GET'
        )
        if (response && response.user) {
          this.loading = false
          if (response.user && response.user.name) {
            this.matching_user = response.user.name
            store.commit('general/SET_TEMPORARY_CSRF', response.user.csrf)
          }
        } else {
          this.$router.push({ path: `/` })
        }
      }
    },
    async submit() {
      if (!this.invalid) {
        this.btnLoading = true
        let response = await helpers.fetchApi(config.apiUrl + `change-password-using-token`, 'POST', {
          change_password: this.change_password,
          country_code: this.$route.params.countrycode,
          _csrf: this.$store.state.general.tempcsrf
        })
        if (response.statusCode == 200) {
          this.$store.commit('general/SET_LOADING', { state: false })
          this.$store.commit('general/SET_SNACKBAR', {
            msg: response.message,
            status: ' white',
            color: 'success'
          })
          this.$router.push({ name: 'Login', params: { countrycode: this.$route.params.countrycode, allowed: true } })
        } else {
          console.log(response)
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_variables.scss';
.flex-row-wrapper {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
}
.flex-href {
  overflow-y: auto;
  padding: 2em;
  color: #428bca !important;
}
.flex-href:hover {
  cursor: pointer;
  color: lightgray !important;
}
.fg-1 {
  flex-grow: 1;
}
.secondary-btn {
  background-color: #333 !important;
}
</style>
